module.exports = __webpack_public_path__ + "statics/img/cate2-5@2x.06e48108.png";